import {Link} from 'react-router-dom';
import React from "react";
import '../App.css'
import {useProviderProfile} from "../../ProviderProfileProvider";
import {LinkWithParams} from "../../util/NavUtils";

interface Props {
  icon: string,
  link: string,
  text: string,
}

export const LeftNavIcon = (props: Props) => {

  return <LinkWithParams to={props.link}>
    <div className={'left-nav-item'}>
      <img className={'left-nav-icon left-nav-icon-available'} src={props.icon}/>
      {props.text}
    </div>
  </LinkWithParams>
};